<template>
  <div class="ac-snooze ac-card-content">
    <div class="ac-header-container">
      <div class="grid-column ai-c jc-s gap-16">
        <button
          class="ac-close-button"
          type="button"
          @click="toggleActionModal(false)"
        >
          <img
            src="@shared/assets/img/general/x-black.png"
            alt="x"
            class="ac-close"
          >
        </button>
        <div class="ac-header">
          Snooze
        </div>
      </div>
    </div>
    <div
      v-if="!leadDetail.snoozeLimitReached"
      class="ac-body-container"
    >
      <div class="ac-input-container">
        <div class="ac-input-header">
          Snooze for:
        </div>
        <SACButtonSelect
          :value="snoozeDay"
          :options="[{
            label: 'Tomorrow',
            value: 1,
            show: true,
          }, {
            label: '2 Days',
            value: 2,
            show: true,
          }, {
            label: '3 Days',
            value: 3,
            show: true,
          }, {
            label: '7 Days',
            value: 7,
            show: true,
          }, {
            label: 'Custom',
            value: 'custom',
            show: true,
          }]"
          :onSelect="(value) => change('snoozeDay', value)"
        >
          <template #custom>
            <input
              :class="[
                'ac-custom-days',
                snoozeDay === 'custom' ? 'show' : 'hide',
              ]"
              type="number"
              placeholder="Enter days"
              :value="customSnoozeDay"
              @change="(e) => change('customSnoozeDay', e.target.value)"
            >
          </template>
        </SACButtonSelect>
        <div
          v-if="errorObj.snoozeDayErr"
          class="ac-input-error"
        >
          {{ errorObj.snoozeDayErr }}
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Select Reason
        </div>
        <SACButtonSelect
          :value="actionReason"
          :options="[{
            label: 'Customer did not answer',
            value: 'no answer',
            show: true,
          }, {
            label: 'Customer delayed service',
            value: 'delayed service',
            show: true,
          }, {
            label: 'Other',
            value: 'other',
            show: true,
          }]"
          :onSelect="(value) => change('actionReason', value)"
        />
        <div
          v-if="errorObj.actionReasonErr"
          class="ac-input-error"
        >
          {{ errorObj.actionReasonErr }}
        </div>
      </div>
      <div class="ac-input-container">
        <div class="ac-input-header">
          Notes
          <span
            v-if="actionReason !== 'other'"
            class="ac-input-sub"
          >(Optional)</span>
          <span
            v-else
            class="ac-input-sub red-text"
          >
            (required)
          </span>
        </div>
        <textarea
          placeholder="Leave a note here..."
          :value="actionNote"
          @change="change('actionNote', $event.target.value)"
        />
        <div class="ac-input-footer-container">
          <div
            v-if="errorObj.actionNoteErr"
            class="sac__font-14 tomato med"
          >
            {{ errorObj.actionNoteErr }}
          </div>
          <div
            class="ac-text-count"
          >
            500 Character Max
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="ac-body-container"
    >
      <p class="ac-p-text">
        This lead has been snoozed 2 times already
      </p>
    </div>
    <div
      v-if="!leadDetail.snoozeLimitReached"
      class="ac-footer-container"
    >
      <button
        class="sac__button bg-transparent"
        type="button"
        @click="toggleActionModal(false)"
      >
        Cancel
      </button>
      <button
        class="sac__button bg-primary margin-left-16"
        :disabled="processingAction"
        type="button"
        @click="serviceSnooze"
      >
        <img
          v-if="processingAction"
          class="ac-processing"
          src="@shared/assets/img/general/loading-white.svg"
          alt="processing"
        >
        <span v-else>Submit</span>
      </button>
    </div>
  </div>
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import SACButtonSelect from '@shared/components/sac/SACButtonSelect.vue';

export default {
  name: 'Snooze',
  components: {
    SACButtonSelect,
  },
  mixins: [serviceMixin],
  data() {
    return {
      actionNote: '',
      customSnoozeDay: 0,
      snoozeDay: 0,
      actionReason: '',
      errorObj: {},
    };
  },
  methods: {
    change(f, v) {
      this[f] = v;
    },
    isValid() {
      const temp = {};
      if (!this.snoozeDay) {
        temp.snoozeDayErr = 'Please select days';
      }
      if (this.snoozeDay === 'custom' && !this.customSnoozeDay) {
        temp.snoozeDayErr = 'Please enter days';
      }
      if (!this.actionReason) {
        temp.actionReasonErr = 'Please select reason';
      }
      this.errorObj = { ...temp };
      return Object.keys(this.errorObj).length === 0;
    },
    async serviceSnooze() {
      if (this.isValid()) {
        const actionReq = {
          ...this.actionRequest,
          actionReason: this.actionReason,
          snoozeDay: this.snoozeDay,
          actionNote: this.actionNote,
          customSnoozeDay: this.customSnoozeDay,
        };
        await this.$store.dispatch('updateAlertNoticeAction', actionReq);
        this.toggleActionModal(false);
      }
    },
  },
};
</script>

  <style lang="scss">
  .ac-snooze {
    .ac-snooze-title {
      margin-left: 10px;
      font-size: 24px;
      font-weight: 600;
      line-height: 24px;
      text-align: left;
    }
    .ac-custom-days {
      width: 200px !important;
      &.show {
        animation: growDown 0.25s ease;
      }
      &.hide {
        animation: growUp 0.25s ease;
      }
    }
  }

  @keyframes growUp {
    0% {
      height: 48px;
    }
    100% {
      height: 0;
    }
  }

  @keyframes growDown {
    0% {
      height: 0px;
    }
    100% {
      height: 48px;
    }
  }
  </style>
